module.exports = __webpack_public_path__ + "static/media/img-6.a11a58fe.jpg";